import React, { useEffect, useState, useContext } from "react";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { LanguageContext } from "App";
import { useLocation } from "react-router-dom";
import AppointmentsApi from "../../../Classes/API/Appointments/AppointmentsApi";
import SearchStringOrIntReq from "../../../Classes/Models/Requests/SearchStringOrIntReq";
import Swal from "sweetalert2";
import { Card, CardHeader } from "@mui/material";
import HourAppointmentsTable from "./HourAppointmentsTable";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Loader from "layouts/loader/loader";
import "./style.scss";
import MDButton from "components/MDButton";

const index = () => {
  const { translations, switchLanguage } = useContext(LanguageContext);
  const { state } = useLocation();
  const [IsLoading, setIsLoading] = useState(false);
  const [AppDay, setAppDay] = useState([]);
  const [Hour, setHour] = useState(9);
  const [dateDay, setdateDay] = useState();

  useEffect(async () => {
    await GetAppHoursByhour(state.AppDay.id, Hour);
  }, []);

  useEffect(() => {}, [AppDay]);

  const GetAppDayById = async (Id) => {
    let req = new SearchStringOrIntReq();
    req.SearchInt = Id;

    let res = await AppointmentsApi.GetAppointmentDayByIdSimplified(req);

    if (res.status == "Success") {
      setAppDay(res.data);
    } else {
      Swal.fire("Failed", res.message, "error");
    }
  };

  const GetAppHoursByhour = async (Id, hour) => {
    if (Hour != hour) {
      setHour(hour);
    }
    if (!IsLoading) {
      setIsLoading(true);
    }
    let req = new SearchStringOrIntReq();
    req.SearchInt = Id;
    req.HoursIndex = hour;

    let res = await AppointmentsApi.GetAppointmentDayHoursByHours(req);

    if (res.status == "Success") {
      setAppDay(res.data);
      setIsLoading(false);
    } else {
      Swal.fire("Failed", res.message, "error");
    }
  };

  const OnchangeHour = async (hour) => {
    setHour(hour);
    await GetAppHoursByhour(state.AppDay.id, Hour);
  };

  const ExportExcel = async () => {
    Swal.fire({
      title: "Exporting",
      icon: "info",
      text: "Please wait",
      didOpen: () => {
        Swal.showLoading();
      },
    });
    let req = new SearchStringOrIntReq();
    req.SearchInt = state.AppDay.id;

    let res = await AppointmentsApi.ExportAppointmentDay(req);
    var csvURL = window.URL.createObjectURL(res);
    let tempLink = document.createElement("a");
    tempLink.href = csvURL;
    tempLink.setAttribute("download", "AppointmentDay.xlsx");
    tempLink.click();
    Swal.fire({
      title: "Exported",
      icon: "success",
      text: "Exported successfully",
    });
  };

  const ExportExcelList = async () => {
    Swal.fire({
      title: "Exporting",
      icon: "info",
      text: "Please wait",
      didOpen: () => {
        Swal.showLoading();
      },
    });

    let req = new SearchStringOrIntReq();
    // req.SearchInt = AppDay[0].appointmentDayId;
    req.SearchInt = state.AppDay.id;
    let res = await AppointmentsApi.ExportAccountingDay(req);
    var csvURL = window.URL.createObjectURL(res);
    let tempLink = document.createElement("a");
    tempLink.href = csvURL;
    tempLink.setAttribute(
      "download",
      "AppointmentDay " +
        new Date(state.AppDay.dateDay).toLocaleDateString() +
        ".xlsx"
    );
    tempLink.click();
    Swal.fire({
      title: "Exported",
      icon: "success",
      text: "Exported successfully",
    });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Card>
        <CardHeader title={translations.HourDetails} />

        <MDBox
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap={3}
          sx={{ padding: "1.5em" }}
        >
          {/* ===== Buttons Row ===== */}
          <MDBox display="flex" gap={2}>
            <MDButton
              sx={{
                backgroundColor: "#3560AD",
                "&:hover": { backgroundColor: "#4682B4" },
                minWidth: "180px",
              }}
              color="text"
              onClick={ExportExcel}
            >
              {translations.appointmentPatientsEnteriesSchedule}
            </MDButton>

            <MDButton
              sx={{
                backgroundColor: "#3560AD",
                "&:hover": { backgroundColor: "#4682B4" },
                minWidth: "180px",
              }}
              color="text"
              onClick={ExportExcelList}
            >
              {translations.appointmentPatientsEnteriesDailyPatientRepor}
            </MDButton>
          </MDBox>

          {/* ===== Date & Hour Row ===== */}
          <MDBox
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap={1}
          >
            <MDTypography variant="h6" color="text" sx={{ fontWeight: 500 }}>
              {translations.appointmentPatientsEnteriesSelectedDate}{" "}
              {new Date(state.AppDay.dateDay).toLocaleDateString("en-GB")}
            </MDTypography>

            <select
              value={Hour}
              onChange={(e) =>
                GetAppHoursByhour(state.AppDay.id, Number(e.target.value))
              }
              style={{
                padding: "10px 15px",
                borderRadius: "8px",
                border: "1px solid #ccc",
                fontSize: "16px",
                minWidth: "150px",
                textAlign: "center",
              }}
            >
              {Array.from({ length: 24 }, (_, i) => (
                <option key={i} value={i}>
                  {String(i).padStart(2, "0")}:00
                </option>
              ))}
            </select>
          </MDBox>
        </MDBox>

        {IsLoading ? (
          <Loader />
        ) : (
          <HourAppointmentsTable SelectedApps={AppDay} />
        )}
      </Card>
    </DashboardLayout>
  );
};

export default index;
